import React, { useState, useEffect, useCallback } from "react";
import { withAppHOC } from "../../../hoc";
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  NumberInput,
  MessageBox,
  CreateButton,
  ResetButton,
  Dropdown
} from '../../../components/FormElements';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';

const PackagesCreate = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [packageName, setPackageName] = useState('');
  const [packageType, setpackageType] = useState('');
  const [description, setDescription] = useState('');
  const [chargePerHit, setChargePerHit] = useState('');
  const [price, setPrice] = useState('');
  const [duration, setDuration] = useState('');

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const packageTypeOptions = [
    { title: '-- SELECT PACKAGE TYPE --', value: '' },
    { title: 'Fixed', value: 'Fixed' },
    { title: 'Pay As you Go', value: 'Pay As you Go' },
  ];

  const resetForm = () => {
    setPackageName('');
    setDuration('');
    setChargePerHit('');
    setpackageType('');
    setDescription('');
    setPrice('');
  };

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.post('/packages', {
      packageName,
      packageType,
      description,
      price,
      chargePerHit,
      duration,
    })
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          resetForm();
          setTimeout(() => {
            resetResponseData();
            window.location.href = '/accounting/packages';
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method='POST' action='#' onSubmit={onSubmit}>
          <GridItem>
            <Fieldset>
              <Label required>Package Name</Label>
              <TextInput
                placeholder='Please enter package name'
                value={packageName}
                onChange={setPackageName}
                maxLength={200}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Description</Label>
              <TextInput
                placeholder='Please Enter Description'
                value={description}
                onChange={setDescription}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Amount</Label>
              <NumberInput
                placeholder='Please Enter Package Price'
                value={price}
                onChange={setPrice}
                autoComplete='off'
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          <GridItem>
            <Fieldset>
              <Label required>Package Type</Label>
              <Dropdown
                placeholder='Please select Package Type'
                value={packageType}
                onChange={setpackageType}
                options={packageTypeOptions}
                disabled={isLoading}
              />
            </Fieldset>
          </GridItem>
          {packageType === 'Fixed' && (
            <GridItem>
              <Fieldset>
                <Label required>Duration</Label>
                <TextInput
                  placeholder='Please enter plan duration in days'
                  value={duration}
                  onChange={setDuration}
                  autoComplete='off'
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          )}
          {packageType === 'Pay As you Go' && (
            <GridItem>
              <Fieldset>
                <Label required>Charge Per Hit</Label>
                <NumberInput
                  placeholder='Please enter Charge Per Hit'
                  value={chargePerHit}
                  onChange={setChargePerHit}
                  autoComplete='off'
                  disabled={isLoading}
                />
              </Fieldset>
            </GridItem>
          )}

          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <CreateButton disabled={isLoading} type='submit'>
              Create
            </CreateButton>
            <ResetButton disabled={isLoading} type='button' onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(PackagesCreate);
